<template>
  <nav aria-label="breadcrumb">
    <ul class="breadcrumb">
      <li
        v-for="(crumb, index) in links"
        :key="index"
        :class="{ active: index === links.length - 1 }"
      >
        <router-link v-if="index !== links.length - 1" :to="crumb.to">{{
          crumb.name
        }}</router-link>
        <span v-else>{{ crumb.name }}</span>
        <feather-icon
          v-if="index !== links.length - 1"
          icon="ChevronsRightIcon"
          svgClasses="text-primary"
          class="ml-2"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    links: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((link) => link.name && link.to);
      },
    },
  },
};
</script>

<style scoped>
nav {
  height: 1rem;
  position: relative;
  margin-bottom: 0.5rem;
}
.breadcrumb {
  display: flex;
  list-style: none;
  padding: 0;
  align-items: center;
}
ul.breadcrumb {
  position: absolute;
  z-index: 41005;
  top: -1rem;
}

.breadcrumb li {
  display: flex;
  align-items: center;
}

.breadcrumb li span,
.breadcrumb li router-link {
  margin-right: 0.5rem;
}
</style>
